import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { fetchProgramReviewsNotificationsCountIfNeeded } from '@pec/aion-ui-core/actions/fetchProgramReviewsNotificationsCount';

export const useProgramReviewsBadge = (clientId: string, contractorId: string) => {
  const dispatch = useDispatch();
  const programReviewsData = useSelector(
    (state: CommonRootState) => state.programReviewsNotifications[contractorId] || { count: 0, isFetching: false }
  );

  React.useEffect(() => {
    if (clientId && contractorId) {
      dispatch(fetchProgramReviewsNotificationsCountIfNeeded(clientId, contractorId));
    }
  }, [dispatch, clientId, contractorId]);

  return { count: programReviewsData.count, isFetching: programReviewsData.isFetching };
};
